import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MenuService } from './services/menu.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent{

}
